import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle, Field, Fieldset, Label, } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { TfiSave } from "react-icons/tfi";
import { WPQTIconButton } from "../common/Button/Button";
import { WPQTTooltip } from "../Tooltip/WPQTTooltip";
function WPQTModal({ modalOpen, closeModal, children, size = "sm" }) {
    const sizeClasses = {
        sm: "wpqt-max-w-sm",
        md: "wpqt-max-w-lg",
        lg: "wpqt-max-w-4xl",
        xl: "wpqt-max-w-6xl",
    };
    return (_jsxs(Dialog, { open: modalOpen, as: "div", className: "wpqt-relative wpqt-z-9999 focus:wpqt-outline-none", onClose: closeModal, children: [_jsx(DialogBackdrop, { className: "wpqt-fixed wpqt-inset-0 wpqt-bg-black/40" }), _jsx("div", { className: "wpqt-fixed wpqt-inset-0 wpqt-z-10 wpqt-w-screen wpqt-overflow-y-auto", children: _jsx("div", { className: "wpqt-mt-[8vh] wpqt-flex wpqt-justify-center", children: _jsxs(DialogPanel, { transition: true, className: `data-[closed]:wpqt-transform-[wpqt-scale(95%)] wpqt-relative wpqt-mt-[20px] wpqt-w-4/5 ${sizeClasses[size]} wpqt-rounded-xl wpqt-bg-white wpqt-p-8 wpqt-backdrop-blur-2xl wpqt-duration-300 wpqt-ease-out data-[closed]:wpqt-opacity-0`, children: [_jsx("div", { className: "wpqt-group wpqt-absolute wpqt-right-[-20px] wpqt-top-[-20px] wpqt-flex wpqt-h-[40px] wpqt-w-[40px] wpqt-cursor-pointer wpqt-items-center wpqt-justify-center wpqt-rounded-full wpqt-border wpqt-border-solid wpqt-bg-white wpqt-text-qtBorder", onClick: closeModal, children: _jsx(XMarkIcon, { className: "wpqt-icon-blue group-hover:wpqt-icon-red wpqt-size-5" }) }), children] }) }) })] }));
}
function WPQTModalTitle({ children }) {
    return (_jsx(DialogTitle, { as: "div", className: "wpqt-text-base/7 wpqt-font-medium wpqt-text-black", children: children }));
}
function WPQTModalFieldSet({ children }) {
    return _jsx(Fieldset, { children: children });
}
function WPQTModalField({ label, children, tooltipId, tooltipText, }) {
    const showToolTip = tooltipId && tooltipText;
    const tooltipAttributes = showToolTip
        ? {
            "data-tooltip-id": tooltipId,
            "data-tooltip-content": tooltipText,
            "data-tooltip-position-strategy": "fixed",
            "data-tooltip-variant": "info",
            "data-tooltip-place": "top-end",
        }
        : {};
    return (_jsxs(Field, { className: "wpqt-mb-3", children: [_jsx(Label, Object.assign({ className: "wpqt-mb-2 wpqt-block wpqt-text-sm/6 wpqt-font-medium" }, tooltipAttributes, { children: label })), children, showToolTip && _jsx(WPQTTooltip, { id: tooltipId })] }));
}
function WPQTModalFooter({ onSave, saveBtnText, loading = false, }) {
    return (_jsx("div", { className: "wpqt-mt-4 wpqt-flex wpqt-justify-end", children: _jsx(WPQTIconButton, { text: saveBtnText, loading: loading, icon: _jsx(TfiSave, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: onSave }) }));
}
export { WPQTModal, WPQTModalField, WPQTModalFieldSet, WPQTModalFooter, WPQTModalTitle, };
